import React from "react";
// Utils
import { orderBy } from "lodash";
import { formatPostTime, formatPeriod } from "@tvg/formatter/dates";
import { Icon, Paragraph, Saddle } from "@tvg/design-system";

// Components
import {
  BettingInterest,
  JockeyChange,
  RaceTypeCodeEnum
} from "@tvg/ts-types/Race";
import {
  List,
  Time,
  Dt,
  Dl,
  ChangeLblContainer,
  Runner,
  ChangesDivisor
} from "./styled-components";

// Types

interface JockeyChangesProps {
  changes: JockeyChange[];
  bettingInterests?: BettingInterest[];
  raceTypeCode: RaceTypeCodeEnum;
}

const JockeyChanges = ({
  bettingInterests,
  changes,
  raceTypeCode
}: JockeyChangesProps) => {
  if (!changes || !changes.length) {
    return null;
  }

  return (
    <ChangesDivisor>
      <Paragraph qaLabel="jockeys-changes" fontFamily="bold">
        {raceTypeCode === RaceTypeCodeEnum.HARNESS ? "DRIVERS" : "JOCKEYS"}
      </Paragraph>
      <List>
        {orderBy(changes, ["date"], ["desc"]).map((change) => {
          const bettingInterest = bettingInterests?.find(
            (bInterest: BettingInterest) =>
              bInterest.biNumber === +change.runnerId
          );

          const saddleColor = bettingInterest?.saddleColor;
          const numberColor = bettingInterest?.numberColor;

          return (
            <li key={`jockey-change-${change.date}}`}>
              <Time>
                {formatPostTime(change.date)} {formatPeriod(change.date)}
              </Time>
              <Dl>
                <Dt>
                  <strong>Change</strong>
                  <Runner>
                    <Saddle
                      number={change.runnerId || ""}
                      size="s"
                      numberColor={numberColor}
                      saddleColor={saddleColor}
                    />
                  </Runner>
                  <ChangeLblContainer>
                    <span>{change.oldValue || "Set to\u00A0"}</span>
                    {change.newValue && change.oldValue && (
                      <Icon name="arrowRight" size="s" ml="4" mr="4" />
                    )}
                    {change.newValue && <strong>{change.newValue}</strong>}
                  </ChangeLblContainer>
                </Dt>
              </Dl>
            </li>
          );
        })}
      </List>
    </ChangesDivisor>
  );
};

export default JockeyChanges;
